export const WORKSPACE_STATUS_REFRESH_EVENT = 'antioch-workspace-status-refresh';

export interface WorkspaceStatusRefreshEventDetail {
  reason: string;
}

export function requestWorkspaceStatusRefresh(reason: string): void {
  if (typeof window === 'undefined') return;
  window.dispatchEvent(
    new CustomEvent<WorkspaceStatusRefreshEventDetail>(WORKSPACE_STATUS_REFRESH_EVENT, {
      detail: { reason },
    })
  );
}
